import React from "react";

const SignUpPage = () => {
  return (
    <>

      {/* SignUpLayer */}

    </>
  );
};

export default SignUpPage; 
